module.exports = __webpack_public_path__ + "img/pause.a2ca7c09.png";